
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        textAlign: "center",
        padding: "24px 16px",
        backgroundColor: "#121212",
        color: "#fff",
        marginTop: "40px",
      }}
    >
      <p>
        © {new Date().getFullYear()} GatherYou.
        All rights reserved.
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
          marginTop: "12px",
        }}
      >
        <Link to="/about" style={linkStyle}>
  About Us
</Link>
        <a href="/guides/" style={linkStyle}>
          Guides
        </a>
        <Link to="/help" style={linkStyle}>
          Contact Us / Help
        </Link>

        <Link to="/privacy" style={linkStyle}>
          Privacy Policy
        </Link>

        <Link to="/terms" style={linkStyle}>
          Terms & Conditions
        </Link>
      </div>
    </footer>
  );
}

const linkStyle = {
  color: "#aaa",
  textDecoration: "none",
};
